exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".places_item:after{background:none!important}.places_item,.places_item:hover{transition:all .5s ease}.places_item:hover{filter:grayscale(60%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-539cd5df","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/places/ItemPlace.vue
// module id = 279
// module chunks = 0